const getUnitPrice = (orginAmount, originQuantity) => {
  try {
    const amount = Number(orginAmount);
    let quantity = Number(originQuantity);
    if (Number.isNaN(amount) || Number.isNaN(quantity)) {
      return 0;
    }
    quantity = quantity === 0 ? 1 : quantity;
    return _.round(amount / quantity, 2);
  } catch (e) {
    return 0;
  }
};

/**
 * A wrapper based on built-in toFixed function
 * @requires Lodash
 * @param {number} val
 * @param {number} decimalDigits
 */
const toFixedDecimal = (val, decimalDigits = 2) => {
  if (!_.isNumber(val) || !_.isNumber(decimalDigits)) {
    return '0.00';
  }
  return val.toFixed(decimalDigits);
};

export {
  getUnitPrice,
  toFixedDecimal,
};



// WEBPACK FOOTER //
// ./src/utils/mathUtil.js